import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography'
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import CircularProgress from '@material-ui/core/CircularProgress';
import {withRouter} from "react-router-dom";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { inject, observer } from 'mobx-react';
import {pending, error, done} from '../stores/State'

@inject('store')
@observer
class Accounts extends Component {

  componentDidMount(){
    this.fetchAccounts();
  }

  fetchAccounts(){
    const { accountStore } = this.props.store;
    accountStore.fetchAccounts();
  }

  handleRowClick(account){
    this.props.history.push(`/accounts/${account.id}`);    
  }
  render() {
    const { classes } = this.props;
    const { accountStore } = this.props.store;
    
    return (
      <Grid container spacing={24}>
        <Grid item xs={12}>
          <Typography variant='display3'>Accounts </Typography>
        </Grid>
        <Grid item xs={6}>
          <Paper className={classes.paper}>
            <Typography variant='subheading'>Available accounts</Typography>
            { accountStore.accountsState === pending && <CircularProgress /> }
            { accountStore.accounts && 
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell>Account name</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {accountStore.accounts.map(account => {
                    return (
                      <TableRow key={account.id} hover onClick={()=>this.handleRowClick(account)}>
                        <TableCell>{account.name}</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table> }
            </Paper>
          </Grid>
        </Grid>
    );
  }
}

const styles = theme => ({
  paper: {
    padding: 20
  }
});

Accounts.propTypes = {
  
}

export default withRouter(withStyles(styles)(Accounts));



// WEBPACK FOOTER //
// ./src/components/Accounts.js